import properties from 'properties';
import AppUtil from 'js/utils/AppUtil';
import AppHelper from 'js/app/AppHelper';
import { APP_URL_CONSTANTS } from '../../../common/constants/GlobalConstants';
import {OUTLOOK_CONFIG_CONSTANT} from '../constants/OutlookConfigConstants'

export const populateWorkRequestListingData = data => {
    const w_data = {
        currentProject : data.filter(prj => prj.id === AppHelper.getAppData('projectId') ),
        otherProjects : data.filter(prj => prj.id !== AppHelper.getAppData('projectId') )
    }

    return {
        type: OUTLOOK_CONFIG_CONSTANT.LOAD_OUTLOOK_WORKREQUEST_CONFIG,
        payload: {
            data: w_data
        }
    }
}

/* istanbul ignore next */
export const getWorkRequestListing = () => {
    let w_userId = AppHelper.getParamData('sologinid');
    if(!w_userId) {
        w_userId =  AppHelper.getParamData("soexturid")
    }
    return dispatch => {
        const url = properties.isIntegrated ? properties.url + APP_URL_CONSTANTS.GET_ALL_WORK_REQUESTS + "/" + AppHelper.getParamData('icentid')
        + "/" + w_userId: "data/workRequestForOutlook.json";

        AppUtil.ajax(url, undefined, response => {
            dispatch(populateWorkRequestListingData( response ));
        });
    }
}

export const updateWorkRequestData = data => {
    return {
        type: OUTLOOK_CONFIG_CONSTANT.UPDATE_WORKREQUEST_DATA,
        payload: {
            data
        }
    }
}